module.exports = "<iframe [src]=\"sanitizier.bypassSecurityTrustResourceUrl(url)\" width=\"100%\" height=\"100%\" style=\"border: none;\">\r\n</iframe>"